

















import { Component, Vue } from 'vue-property-decorator'

@Component
export default class IntroductionOverlay extends Vue {
    modalOpen = false

    showOverlay() {
        this.modalOpen = true

        this.$store.commit( 'globalModule/setIntroState' )
        this.$store.commit( 'globalModule/setBodyFixed' )
    }

    closeOverlay( event: Event ) {
        event.preventDefault()

        this.modalOpen = false
        this.$store.commit( 'globalModule/setBodyFixed' )
    }
}
